// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2020project/20200701cqfootballnews',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  listData: {
    type: 'com',
  },
  themeColor: {
    activeBgColor: 'rgb(19, 86, 128)',
    inactiveBgColor: 'rgb(187, 211, 220)',
  },
  tabs: [
    {
      tabName: 'zua球时刻',
      tabPath: '/20200701cqfootballnews/News',
      active: require('./assets/inactive-News.jpg'),
      inActive: require('./assets/active-News.jpg'),
    },
    {
      tabName: '温度山城',
      tabPath: '/20200701cqfootballnews/News2',
      active: require('./assets/inactive-News2.jpg'),
      inActive: require('./assets/active-News2.jpg'),
    },
    {
      tabName: '千翻场外',
      tabPath: '/20200701cqfootballnews/News3',
      active: require('./assets/inactive-News3.jpg'),
      inActive: require('./assets/active-News3.jpg'),
    },
  ],
};
